<template lang='pug'>
  div(:class='$style[`cc-input-searchbar`]')

    input(
      type='text'
      ref='searchInputer'
      :placeholder='!plhShow ? `` : plh'
      :class='$style[`cc-input-area`]'
      @input='onInputChange($event.target.value)'
      @focus='onInputFocus'
      @blur='onInputBlur'
    )

    span(:class='$style[`cc-input-before-icon`]')
      IconSearch(:size='16' :color='`#fff`')

    span(
      v-show='changeValue'
      :class='$style[`cc-input-reset`]'
      @click='onInputResetClick')
      IconClose(:size='16' :color='`#98A1A1`')

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IconClose from '../../icon/Close';
import IconSearch from '../../icon/Search';

export default {
  components: {
    IconClose,
    IconSearch,
  },

  model: {
    prop: 'changeValue',
    event: 'input',
  },

  props: {
    placehold: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: String,
      default: '',
    },
    changeValue: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      plh: this.placehold,
      plhShow: true,
    };
  },

  mounted() {
    this.$refs.searchInputer.value = this.defaultValue;
  },

  methods: {
    onInputResetClick() {
      this.$emit('input', '');
      this.$refs.searchInputer.value = '';
      this.changeSearchBar(false);
    },

    onInputChange(newValue) {
      // console.log('Input SearchBar onChange!!!', newValue);
      // eslint-disable-next-line no-unused-expressions
      newValue ? this.changeSearchBar(true) : this.changeSearchBar(false);
      this.$emit('input', newValue);
    },

    onInputFocus() {
      this.plhShow = false;
      if (this.changeValue) {
        this.changeSearchBar(true);
      }
    },

    onInputBlur() {
      this.plhShow = true;
      // if (this.rwdType !== 'desktop') { return; }
      // this.changeSearchBar(false);
    },

    ...mapActions({
      changeSearchBar: 'user/changeTopBarSearchBarFocus',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      rwdType: 'global/exportRwdType',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch:{
    $route(to, from) {
      this.$emit('input', '');
      this.$refs.searchInputer.value = '';
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/topbar/inputSearch.scss';
</style>
